import * as actionTypes from '../actionTypes';

export const initialValues = {
    basicUserInfo: null,
    legalAgreements: [],
}

export const initialUserSetup = (state = initialValues, action) => {
    switch (action.type) {
        case actionTypes.SET_BASIC_USER_INFO: {
            return {
                ...state,
                basicUserInfo: action.payload.basicUserInfo,
            }
        }
        case actionTypes.SET_GUARDIAN_INFORMATION: {
            return {
                ...state,
                basicUserInfo: {
                    ...state.basicUserInfo,
                    guardianInfo: action.payload.guardianInfo, 
                }
            }
        }
        case actionTypes.SIGNUP_ERROR: {
            return {
                ...state,
                signupError: action.payload.signupError,
            }
        }
        case actionTypes.CLEAR_SIGNUP_ERROR: {
            return {
                ...state,
                signupError: null,
            }
        }
        default:
            return state;
    }
};
